import { AxiosResponse } from 'axios';

import ApiService from './ApiService';

export async function sendIdentityVerificationRequest(applicationId: string | undefined): Promise<AxiosResponse> {
  return await ApiService.sendIdentityVerificationRequest({ applicationId: applicationId });
}
